/** @jsxImportSource @emotion/react */
import { css } from '@emotion/core'
import { gsColors } from './Variables.js'
import localFont from "next/font/local";

export const brown = localFont({
  src: [
    { path: "../fonts/Brown-Light.woff2", weight: "300", style: "normal" },
    { path: "../fonts/Brown-Regular.woff2", weight: "400", style: "normal" },
    { path: "../fonts/Brown-Bold.woff2", weight: "700", style: "normal" },
  ],
  variable: "--font-brown"
});

export const euclid = localFont({
  src: [
    { path: "../fonts/euclid/EuclidCircularA-Regular.otf", weight: "400", style: "normal" },
    { path: "../fonts/euclid/EuclidCircularA-RegularItalic.otf", weight: "400", style: "italic" },
    { path: "../fonts/euclid/EuclidCircularA-Medium.otf", weight: "600", style: "normal" },
    { path: "../fonts/euclid/EuclidCircularA-Bold.otf", weight: "700", style: "normal" },
  ],
  variable: "--font-euclid",
});

export const garnett = localFont({
  src: [
    { path: "../fonts/garnett/Garnett-Regular.otf", weight: "400", style: "normal" },
    { path: "../fonts/garnett/Garnett-Semibold.otf", weight: "600", style: "normal" },
    { path: "../fonts/garnett/Garnett-Bold.otf", weight: "700", style: "normal" },
  ],
  variable: "--font-garnett",
});

const GlobalStyles = css`
  scroll-behavior: smooth;

  :root {
    --font-euclid: 'Euclid', sans-serif;
    --font-brown: 'Brown', sans-serif;
    --font-garnett: 'Garnett', sans-serif;
  }

  html {
    box-sizing: border-box;
    font-size: 100%;
    scroll-behavior: smooth;
    font-family: var(--font-brown);


    .react-datepicker {
      font-family: var(--font-brown) !important;
    }
  }

  html:focus-within {
    scroll-behavior: smooth;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    background-color: ${gsColors.white};
    color: ${gsColors.black};
    font-family: var(--font-brown), sans-serif;
    font-weight: normal;
    line-height: 1.625;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  [data-af-custom-fonts="af-creatives-text"] {
      font-family: var(--font-brown), sans-serif;
  }


  h1,
  h2,
  p,
  ul {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style: none;
  }

  .show {
    display: block !important;
  }

  .hide {
    display: none !important;
  }

  /* Google Autocomplete */
  .pac-container {
    z-index: 10000 !important;
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .booking-flow {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .react-datepicker__day--selected {
    background-color: ${gsColors.grape};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: black;
    -webkit-box-shadow: 0 0 0px 1000px #FFFFFF inset;
    // transition: background-color 5000s ease-in-out 0s;
  }
`

export default GlobalStyles
